import { render, staticRenderFns } from "./CompareLoadingContent.vue?vue&type=template&id=a9e28826"
import script from "./CompareLoadingContent.vue?vue&type=script&setup=true&lang=ts"
export * from "./CompareLoadingContent.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports